import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase, invokeFunction } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import LoadingState from '@/components/LoadingState';

export default function QuickBooksCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const realmId = searchParams.get('realmId');
      const error = searchParams.get('error');

      if (error) {
        toast.error(`QuickBooks connection failed: ${error}`);
        navigate('/');
        return;
      }

      if (!code || !realmId) {
        toast.error('Invalid QuickBooks callback - missing parameters');
        navigate('/');
        return;
      }

      try {
        // Use Supabase client to invoke the edge function
        const { data, error } = await invokeFunction(supabase, 'quickbooks-oauth', {
          body: {
            action: 'callback',
            code,
            realmId
          }
        });

        if (error) {
          throw new Error(error.message || 'Failed to complete OAuth flow');
        }

        toast.success('Successfully connected to QuickBooks!');
        
        // Close the popup window if this was opened in a popup
        if (window.opener) {
          window.close();
        } else {
          // Navigate back to the organization page
          navigate('/');
        }
        
      } catch (error) {
        console.error('QuickBooks callback error:', error);
        toast.error('Failed to complete QuickBooks connection');
        navigate('/');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingState />
        <p className="mt-4 text-muted-foreground">
          Completing QuickBooks connection...
        </p>
      </div>
    </div>
  );
}